/**
 * Returns Chart.js-compatible chrome colors for the current theme.
 * Reads document.documentElement.dataset.theme (set by layout + FOUC script).
 * Data series colors (bars, lines, pie slices) are NOT handled here —
 * those represent data categories and stay in their own config.
 */
export function getChartThemeColors() {
  const theme = document.documentElement.dataset.theme;
  const isDark = theme === "dark";
  return {
    fontColor: isDark ? "rgba(255, 255, 255, 0.70)" : "#545454",
    gridColor: isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)",
    tickColor: isDark ? "rgba(255, 255, 255, 0.70)" : "#545454",
    tooltipBackgroundColor: isDark ? "#2A2826" : "#FFFFFF",
    tooltipTitleColor: isDark
      ? "rgba(255, 255, 255, 0.92)"
      : "rgba(0, 0, 0, 0.87)",
    tooltipBodyColor: isDark
      ? "rgba(255, 255, 255, 0.92)"
      : "rgba(0, 0, 0, 0.87)",
    tooltipBorderColor: isDark
      ? "rgba(255, 255, 255, 0.14)"
      : "rgba(0, 0, 0, 0.15)",
    legendColor: isDark ? "rgba(255, 255, 255, 0.70)" : "#545454",
  };
}

/**
 * Registers a MutationObserver on <html data-theme> and calls the
 * provided callback whenever the theme changes. Returns a stop function.
 * Use this in chart components to re-render when the user toggles theme.
 */
export function observeThemeChange(callback) {
  if (typeof MutationObserver === "undefined") return () => {};
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "attributes" && m.attributeName === "data-theme") {
        callback();
        return;
      }
    }
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });
  return () => observer.disconnect();
}
